export const tasksPeriodFilterTitles = [
  { value: 'all', label: 'Всі завдання' },
  { value: 'today', label: 'Завдання на сьогодні' },
  { value: 'tomorrow', label: 'Завдання на завтра' },
  { value: 'week', label: 'Завдання на тиждень' },
  { value: 'month', label: 'Завдання на місяць' },
];
